import React from "react";
import { Info, AlertTriangle } from "lucide-react";

/**
 * Reusable disclaimer snippets used across stock detail pages, Deep AI
 * analysis output, and CSE Vision OCR results. Centralised so the
 * wording stays consistent and a future legal tweak is a one-line fix.
 */

export const DataSourceNote = ({ className = "", testId = "data-source-note" }) => (
  <div
    className={`inline-flex items-start gap-1.5 text-[11px] leading-snug text-muted-foreground ${className}`}
    data-testid={testId}
  >
    <Info className="h-3 w-3 mt-0.5 shrink-0 opacity-70" />
    <span>
      Data sourced from third parties. May not be current or accurate. Verify
      from official sources.
    </span>
  </div>
);

export const AiAnalysisWarning = ({ className = "", testId = "ai-analysis-warning" }) => (
  <div
    className={`flex items-start gap-2 rounded-md border border-amber-500/30 bg-amber-500/5 px-3 py-2 text-xs text-amber-900 dark:text-amber-200 ${className}`}
    data-testid={testId}
  >
    <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0 text-amber-600 dark:text-amber-400" />
    <span className="leading-relaxed">
      Analysis based on data that may contain errors or variances. Financial
      figures used in this analysis have not been independently verified.
      Verify all data from official sources before investing.
    </span>
  </div>
);

export const VisionOcrWarning = ({ className = "", testId = "vision-ocr-warning" }) => (
  <div
    className={`flex items-start gap-2 rounded-md border border-amber-500/30 bg-amber-500/5 px-3 py-2 text-xs text-amber-900 dark:text-amber-200 ${className}`}
    data-testid={testId}
  >
    <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0 text-amber-600 dark:text-amber-400" />
    <span className="leading-relaxed">
      Figures extracted from PDF using AI Vision. May contain errors. Verify
      against the original annual report before relying on these figures.
    </span>
  </div>
);

export default DataSourceNote;
